export const datetimeFormats = {
  'en': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric'
    },
    // long: {
    //   year: 'numeric', month: 'short', day: 'numeric',
    //   weekday: 'short', hour: 'numeric', minute: 'numeric'
    // }
  },
  'it': {
    short: {
      day: 'numeric', month: 'short', year: 'numeric', 
    },
    long: {
      day: 'numeric', month: 'short', year: 'numeric', 
      hour: 'numeric', minute: 'numeric'
    },
    // long: {
    //   weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', 
    //   hour: 'numeric', minute: 'numeric'
    // }
  }
}